import format from '../utils/format';

export default {
	install(Vue, options) {
		Vue.prototype.$format = format;
	}
};



// WEBPACK FOOTER //
// ./src/shared/plugins/format.js